@switch (columnName) {
  @case ('action') {
    {{ element.type | translate }}
    <br />
    @if (element.type === 'TransferredComponent' && element.previousDepartmentName) {
      {{ 'previousDepartment' | translate }}: {{ element.previousDepartmentName }}
    }
  }
  @case ('date') {
    {{ element.date | date }}
  }
  @case ('performDate') {
    {{ element.performDate ? (element.performDate | date) : '---' }}
  }
  @case ('runtimeCounter') {
    {{ element.runtimeName ?? '---' }}
  }
  @case ('doneBy') {
    <span class="vertical-center done-by">
      <mat-icon class="material-icons-outlined">person</mat-icon>
      {{ element?.userName }}
      <small>{{ element?.jobPosition }}</small>
    </span>
  }
  @case ('openHistoryEntry__hidden') {
    @if (element.isClickable) {
      <span class="vertical-center">
        <mat-icon>chevron_right</mat-icon>
      </span>
    }
  }
  @default {
    {{ element[columnName] ?? '---' }}
  }
}
